module.exports = __webpack_public_path__ + "img/home.0e5136e6.png";